/* eslint-disable */
/**
 * 白名单（不需要登录，在业务里自己控制）
 */
import { pageArgs } from '@/utils'
export const whiteList = {
  // 不需要授权的白名单路由
  items: [
    // 2022年08月10日
    '#/helpCenter', //帮助中心
    // 2022-08-02新增
    '#/sms_adviser',
    '#/couponMerge',
    '#/commitmentPage',
    '#/infiniteCardDeductionInfo',
    '#/userInfo',
    // 工具
    '#/local-clear', //没起作用?
    '#/login',
    // 合并账号
    '#/mergeAcount',
    '#/mergeAcount-success',
    '#/userMergeAgreement',
    // 30109账户异常提醒页面
    '#/accountError',
    // 导购页
    '#/goods', // 包括 goods 都可无状态访问
    '#/goods_freeget', // 免费获取
    '#/goods_forever', // 无限卡
    '#/goods_lover', // 亲人节
    '#/goods-camp', // 获取最新训练营的url
    // 分享
    '#/share-default',
    '#/share-course',
    '#/share-live',
    '#/course-share',
    '#/gift-card',
    '#/share-coupons',
    '#/record-share',
    '#/mini-app',
    // 小程序分享
    '#/show-pictures', // 页面仅展示，无需登陆
    '#/show-pictures2', // 页面仅展示，无需登陆
    '#/pullnew',
    '#/pullnew2023',
    '#/pullnew/detail',
    //申请短信图片
    '#/apply-code',
    '#/apply-study',
    '#/apply-select',
    '#/confirm-pay',
    '#/receive',
    '#/dailyNewspaper',
    '#/download',
    '#/downDetail',
    '#/questions' //ios审核需要加
  ],
  // 仅需要微信授权的白名单路由（不应出现在items中）
  onlyWxItems: [
    //
  ],
  include(hash) {
    if (hash == null) {
      hash = location.hash
    }
    // 该参数强制切换页面需要授权
    const { needLogin } = pageArgs.args()
    if (needLogin) {
      return false
    }

    const result =
      this.items.filter(item => {
        return hash.indexOf(item) >= 0
      }).length > 0
    console.log(
      '是否白名单',
      result,
      '访问地址:',
      hash,
      this.items.filter(item => {
        return hash.indexOf(item) >= 0
      })
    )
    if (result) {
      // #/goods 学习计划开启强制登录
      if (hash === '#/goods-studyplan') return false
    }

    return result // 在里面
  }
}
